import { Space } from 'antd';
import React from 'react';

import SearchInput from 'components/atoms/SearchInput';
import BackOfficeFilterDrawerTriggerButton from 'components/buttons/BackOfficeFilterDrawerTriggerButton';
import { FilterSetName } from 'store/modules/routerUtils/types';

import './styles.less';

export interface BackOfficeActionsBarProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
  searchInputPlaceholder?: string;
  paginationText?: string;
  /** Pass this prop if you want the FilterDrawerTriggerButton */
  filterSetName?: FilterSetName;
}

function BackOfficeActionsBar({
  children,
  actions,
  searchInputPlaceholder,
  paginationText,
  filterSetName
}: BackOfficeActionsBarProps): JSX.Element | null {
  return (
    <div className="BackOfficeActionsBar-wrapper">
      <div className="BackOfficeActionsBar-container">
        <Space>
          <SearchInput placeholder={searchInputPlaceholder} autoFocusOnLoad />
          {filterSetName && (
            <BackOfficeFilterDrawerTriggerButton
              filterSetName={filterSetName}
            />
          )}
          {paginationText}
        </Space>
        <div className="BackOfficeActionsBar-buttons">{actions}</div>
      </div>
      <div className="BackOfficeActionsBar-pusher">{children}</div>
    </div>
  );
}

export default BackOfficeActionsBar;
